module.exports = __webpack_public_path__ + "media/images/emblems/Flerden_wappen-bda100ceec69cfe970feda03d9291b3d.svg";